import submitForm from "submit-form";

common.View.create('crud::datatable.SelectionActions', {

	selectedIds: [],

	/**
	 * Called when DOM is ready.
	 */
	onDOMLoad()
	{
		this.initDataTable();
		this.initSelectAll();
		this.initShiftClick();
	},

	selectedRows() {
		// Clear previous toasts.
		Vue.toasted.clear();

		// Fire toast.
		if( this.selectedIds.length ) {
			Vue.toasted.show('<i class="fas fa-check text-green-400"></i> Geselecteerde rijen: ' + this.selectedIds.length, {
				position: 'bottom-left',
				iconPack: 'fontawesome',
				singleton: true,
				duration: null,
                closeOnSwipe: false,
			});
		}
	},

	initSelectAll() {
		// Redraw table for selectAll checkbox on different pages.
		this.onTableDraw();

		$('.selectionActionSelectAll').click(() => {
			// Define checked/unchecked selectAll.
			this.checked = !this.checked;

			if (this.checked) {
				// Iterate each selectionAction.
				$('.selectionAction').each((key, checkbox) => {
					// Is disabled?
					if( $(checkbox).attr('disabled') ) {
						return;
					}

					// Check selectionActions if selectAll is checked.
					$(checkbox).prop('checked', this.checked);

					// Add checkboxes val to selectedIds.
					if(this.selectedIds.indexOf($(checkbox).val()) === -1)
						this.selectedIds.push($(checkbox).val());
				});

			} else {

				// Iterate each selectionAction.
				$('.selectionAction').each((key, checkbox) => {
					// Uncheck selectionActions if selectAll is removed.
					$(checkbox).prop('checked', this.checked);

					// Remove checkboxes val from selectedIds.
					_.pull(this.selectedIds, $(checkbox).val());
				});
			}

			this.showOrHideSelectionActions();

			// Enable/disable submit button
			this.element

				// Set amount selected.
				.find('.amountSelected .amount')
					.text(this.selectedIds.length)
					.end()

				// Enable / disabled action buttons.
				.find('button[type="submit"]')
					.attr('disabled', this.selectedIds.length === 0)
					.end();

			// Toast selected rows.
			this.selectedRows();
		});

	},

	initShiftClick() {
		// Define
		let lastChecked = null;

		$( document ).on('click', '.selectionAction', (event) => {
			// Define checkboxes
			let checkboxes = $('.selectionAction');

				if (!lastChecked) {
				lastChecked = event.currentTarget;
				return;
			}

			// On shift event change prop to checked
			if (event.shiftKey) {
				// Checks where index starts
				let start = checkboxes.index(event.currentTarget);

				// Checks where index ends
				let end = checkboxes.index(lastChecked);

				// Define checkboxes with checked
				checkboxes = checkboxes.slice(Math.min(start,end), Math.max(start,end)+ 1).prop('checked', lastChecked.checked);

				// Add to selection?
				if($(checkboxes).is(':checked')) {
					// Add due to not already added?
					checkboxes.each((key, checkbox) => {
						// Is disabled?
						if( $(checkbox).attr('disabled') ) {
							return;
						}

						if(this.selectedIds.indexOf($(checkbox).val()) === -1)
							this.selectedIds.push($(checkbox).val());
					});
				}
				// Remove from selection?
				else {
					checkboxes.each((key, checkbox) => {
						_.pull(this.selectedIds, $(checkbox).val());
					});

					// Remove selection on selectAll.
					this.checked = false;
					$('.selectionActionSelectAll').prop('checked', this.checked);
				}

				// Enable/disable submit button
				this.element
					// Set amount selected.
					.find('.amountSelected .amount')
						.text(this.selectedIds.length)
						.end()

					// Enable / disabled action buttons.
					.find('button[type="submit"]')
						.attr('disabled', this.selectedIds.length === 0)
						.end();
			}

			// Return checked
			lastChecked = event.currentTarget;
		});
	},

	initDataTable() {
		this.element
			// Listen for change click.
			.prev('.dataTables_wrapper')

			.unbind('change')
			.on('change', 'input[name*="items["]', this.onChangeEvent.bind(this))

				// Listen for new data.
				.bind('draw.dt', this.applySelection.bind(this))
				.end()

			.end();
	},

	onTableDraw() {
		// On table draw compare checkbox values with selectedIds.
		let table = $('#dataTableBuilder').DataTable();
		table.on( 'draw', () => {
			this.checkCurrentPageValues();
		});
	},

	checkCurrentPageValues() {
		// Loop through current checkboxes and push values into new array.
		let currentDrawnCheckboxes = [];
		$('.selectionAction').each(function(){
			currentDrawnCheckboxes.push($(this).val());
		});

		// Check if currentDrawnCheckboxes equals selectedIds to add prop checked to selectAll checkbox.
		if(this.selectedIds.length === 0) {
			$('.selectionActionSelectAll').prop('checked', false);
		} else {
			this.checked = currentDrawnCheckboxes.every(ai => this.selectedIds.includes(ai));
			$('.selectionActionSelectAll').prop('checked', this.checked);
		}
	},

	onChangeEvent(event) {
		// Add to selection?
		if($(event.currentTarget).is(':checked')) {
			// Add due to not already added?
			if(this.selectedIds.indexOf($(event.currentTarget).val()) === -1)
				this.selectedIds.push($(event.currentTarget).val());
		}
		// Remove from selection?
		else {
			_.pull(this.selectedIds, $(event.currentTarget).val());

			this.checked = false;
			$('.selectionActionSelectAll').prop('checked', this.checked);
		}

		this.showOrHideSelectionActions();

		// Enable/disable submit button
		this.element

			// Set amount selected.
			.find('.amountSelected .amount')
				.text(this.selectedIds.length)
				.end()

			// Enable / disabled action buttons.
			.find('button[type="submit"]')
				.attr('disabled', this.selectedIds.length === 0)
				.end();

		// Check all current checked checkboxes.
		this.checkCurrentPageValues();

		// Toast selected rows.
		this.selectedRows();
	},

	showOrHideSelectionActions()
	{
		// Check if selection actions are added?
		if( !$('.crud\\:\\:datatable-SelectionActions').length ) {
			console.warn('Selection actions not added yet. See documentation: /docs/basics/datatables#withSelectionActions');
		}

		// Show selection actions?
		if( this.selectedIds.length ) {
			$('.crud\\:\\:datatable-SelectionActions').removeClass('translate-y-full');
		} else {
			$('.crud\\:\\:datatable-SelectionActions').addClass('translate-y-full');
		}
	},

	applySelection() {
		this.element

			.prev('.dataTables_wrapper')

			// Set selection.
			.find('input[name*="items["]')
				.each((index, element) => {
					// Set as selected?
					if(this.selectedIds.indexOf($(element).val()) !== -1)
						$(element)
							.attr('checked', true)
							.prop('checked', true);
				})
				.end()
			.end()

			// Listen for submit clicks.
			.find('button[type="submit"]')
				.click(this.onSelectionActionClick.bind(this))
				.end();
	},

	onSelectionActionClick(event, params)
	{
		/*
        Check if currentTarget has a data confirm.
        In \packages\lav-galaxy\framework\resources\js\common\index.js a Swal gets fired if data-confirm is present on your target.
        Params checks if the confirmation is triggered, then we return so the form won't send.
        The action will then fire again to check if the Swal is confirmed and send the form.
         */
		if($(event.currentTarget).data('confirm') && !params?.send) {
			return;
		}
		this.confirmForm(event);
	},

	confirmForm(event) {
		// Submit
		submitForm(event.currentTarget.getAttribute('data-action'), {
			method: 'POST',
			body: {
				_token: $('meta[name="csrf-token"]').attr('content'),
				items: this.selectedIds,
				inputs: this.element.find(':input').serializeArray(),
			},
		});
	}

});
